import { addressSelectors } from "./Slice";
export const allPatientAddressesSelector = (state) => addressSelectors.selectAll(state.patientAddress);
export const patientAddressById = (state, id) => {
    if (!id) {
        return undefined;
    }
    return addressSelectors.selectById(state.patientAddress, id);
};
